import { mkShare } from './types';

export function transformShareToRequestData(share) {
  return {
    id: share.id,
    clientId: share.clientId,
    datasetId: share.datasetId,

    granteeFirstName: share.granteeFirstName,
    granteeLastName: share.granteeLastName,
    granteeEmail: share.granteeEmail,

    permissions: share.permissions,
    state: share.state,

    testMode: share.testMode,

    isDeleted: share.isDeleted,
  };
}

export const transformResponseToShares = (response) =>
  response.data.resources.map((data) =>
    mkShare({
      id: data.id,
      clientId: data.clientId,

      datasetId: data.datasetId,

      granteeFirstName: data.granteeFirstName,
      granteeLastName: data.granteeLastName,
      granteeEmail: data.granteeEmail,

      grantorFirstName: data.grantorFirstName,
      grantorLastName: data.grantorLastName,
      grantorEmail: data.grantorUsername,

      permissions: data.permissions,
      state: data.state,

      lastAccessedAt: data.lastAccessedAt,

      createdAt: data.createdAt,
      isDeleted: data.isDeleted,
    }),
  );
